import React from 'react'
import { Container, ChartContainer, Bar, Chart, Info, Time } from './OccupancyChart.style'
import Text from '@components/style/Text.style'
import theme from 'parkdepot-shared/theme'
import { useTranslation } from 'react-i18next'

const OccupancyChart = ({
    freeSpots,
    occupancyDistribution,
    lastUpdatedAt
}: {
    freeSpots?: number | null
    occupancyDistribution?: number[] | null
    lastUpdatedAt?: string
}) => {
    const currentHour = new Date().getHours()
    const { t } = useTranslation()

    return (
        <Container>
            {freeSpots !== null && (
                <Info>
                    <Text typography={theme.typography.HeadingLarge} $lineHeight="2rem" fontWeight={600}>
                        {freeSpots}
                    </Text>{' '}
                    <Text typography={theme.typography.LabelMedium} $lineHeight="2rem" fontWeight={600}>
                        {t('occupancy.freeSpaces')}
                    </Text>
                    {lastUpdatedAt && (
                        <Text typography={theme.typography.ParagraphXXSmall} style={{ marginLeft: '1rem' }}>
                            {t('occupancy.lastUpdate')} {new Date(lastUpdatedAt).toLocaleTimeString()}
                        </Text>
                    )}
                </Info>
            )}
            {occupancyDistribution && occupancyDistribution.length > 0 && (
                <ChartContainer>
                    <Chart>
                        {occupancyDistribution.map((value, index) => (
                            <Bar key={index} value={value} colored={index < currentHour} />
                        ))}
                    </Chart>
                    <Time>
                        <span>0</span>
                        <span>3</span>
                        <span>6</span>
                        <span>9</span>
                        <span>12</span>
                        <span>15</span>
                        <span>18</span>
                        <span>21</span>
                        <span>24</span>
                    </Time>
                </ChartContainer>
            )}
        </Container>
    )
}

export default OccupancyChart
